<template>
    <div class="Tabs">
        <div :class="['Tabs-wrapper', {'Tabs-wrapper--border': showBorderBottom}]">
            <div v-for="tab of tabs"
                 :key="tab.componentName"
                 :class="['Tabs-wrapper--title', { 'active-tab': tab.componentName === activeTab }]"
                 :title="tab.tabName"
                 @click="selectTab(tab.componentName)">
                {{ tab.tabName }}
            </div>
        </div>
        <div class="Tabs-slot">
            <slot/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Tabs',

        props: {
            showBorderBottom: {
                type: Boolean,
                default: false
            },

            activeTab: {
                type: String,
                required:false
            },

            tabsList: {
                type: Array,
                default: () => []
            }
        },

        computed: {
            tabs() {
                return this.tabsList && this.tabsList.filter(tab => tab.display);
            }
        },

        methods: {
            selectTab(componentName) {
                this.$emit('changed', componentName);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/styles/variables/colors';

    .Tabs-wrapper {
        display: flex;
        margin: 20px 0 10px;

        &--border {
            border-bottom: 3px solid $ComplementaryBgTxtDarker;
        }

        &--title {
            position: relative;
            margin-right: 35px;
            cursor: pointer;
            font-size: 18px;
            font-weight: 500;
            color: $WhiteGrey;


            @media screen and (max-width: 700px) {
                width: 33%;
                margin-right: 20px;
            }

            &::after {
                content: '';
                position: absolute;
                width: 0;
                bottom: -3px;
                left: 0;
                right: 0;
                height: 3px;
                margin: 0 auto;
                border-radius: 3px;
                background-color: $Yellow;
                transition: width 0.5s;
            }
        }

        .active-tab {
            color: $Light-dark;

            &::after {
                width: 100%;
            }
        }
    }
    .Tabs-slot {
        margin-top: 30px;
    }
</style>


// WEBPACK FOOTER //
// src/components/controls/Tabs.vue